import { RootState } from 'store/types';

export const authSelector = (state: RootState) => state.auth;
export const authToken = (state: RootState) =>
  authSelector(state).token || null;
